<template>
  <div class="entry">
    <div class="top-box">
      <p>于{{time.year}}年{{time.month}}月{{time.day}}日{{time.hour}}:{{time.minute}}生成</p>
      <h3>- 本学期数学掌握度 -</h3>
    </div>
    <div class="box user_box">
      <div class="userInfo">
        <div><img :src="rankInfo.headUrl"></div>
        <p>
          <span>{{rankInfo.name}}</span>
          <span>{{rankInfo.grade + rankInfo.teachBook + rankInfo.term}}</span>
        </p>
      </div>
      <div class="percent_box">
        <div class="itemBox">
          <div class="img_item">
            <img ref="user_img" :style="{left: positionArr.img_box}" :src="rankInfo.headUrl">
          </div>
          <div class="percent_item" ref="percent_item">
            <p ref="percent_box" :style="{width: positionArr.percent_box}"></p>
          </div>
        </div>
        <div class="percent_tips">
          <p ref="arrow_box"><i :style="{left: positionArr.arrow_box}"></i></p>
          <div class="tips_box" :class="{tips_left : score_percent <= 33,tips_middle : (33 < score_percent && score_percent <= 66),tips_right : (66 < score_percent && score_percent <= 100)}">
            <span>{{rankInfo.score}}</span>
            <span>分</span>
            <span>(北京市平均分{{parseInt(rankInfo.average)}}分)</span>
          </div>
        </div>
      </div>
      <div class="user_des">
        <template v-if="rankInfo.scoreGrow>0">
          <i class="up"></i>
          <p>比昨天提高<span>{{rankInfo.scoreGrow}}</span>分</p>
        </template>
      </div>
      <div class="user_des">
        <template v-if="rankInfo.rankGrow<0">
          <i class="down"></i>
          <p>班级排行比昨天下降<span>{{-rankInfo.rankGrow}}</span>名</p>
        </template>
        <template v-if="rankInfo.rankGrow==0">
          <i class="not"></i>
          <p>班级排行维持不变</p>
        </template>
        <template v-if="rankInfo.rankGrow>0">
          <i class="up"></i>
          <p>班级排行比昨天上升<span>{{rankInfo.rankGrow}}</span>名</p>
        </template>
      </div>
      <div class="user_des">
        <i class="up"></i>
        <p>超过北京市<span>{{ Math.round(rankInfo.rankScale*100)}}%</span>的学生</p>
      </div>
      <router-link @click.native="goToDetail()" :to="{path: '/mathReport/detail',query:{token: token, date: date}}">
        <div class="detail_btn">
          章节评分详情
          <i></i>
        </div>
      </router-link>
    </div>
    <div class="box explain">
      <h3>什么是学期数学掌握度？</h3>
      <p>· 从国际公认的科学教育理念出发</p>
      <p>· 基于全国四千万小学生大数据的AI评分</p>
      <p>· 逾十万数学老师正在使用的教学辅助工具</p>
      <router-link @click.native="goToExplain()" :to="{path: '/mathReport/explain', query:{token: token, date: date}}">
        <div class="detail_btn">
          查看详情
          <i></i>
        </div>
      </router-link>
    </div>
    <div class="ranking_box" ref="rank" v-if="ranking_list && ranking_list.length">
      <h3>班级总排行</h3>
      <div v-for="item in ranking_list" class="ranking_list" :class="{active: item.isMe}">
        <span class="ranking_num" :class="{'r1': item.rank==1,'r2': item.rank==2, 'r3': item.rank==3, 'r4': item.rank>3}">{{item.rank<10 ? '0'+item.rank: item.rank}}</span>
        <p class="ranking_mark" v-if="item.grow>0">
          <i class="up"></i>
          <span>{{item.grow}}</span>
        </p>
        <p class="ranking_mark" v-if="item.grow<0">
          <i class="down"></i>
          <span>{{-item.grow}}</span>
        </p>
        <div class="info-wrap clearfix">
          <span class="name">{{item.name}}</span>
          <span class="me" v-if="item.isMe">我</span>
          <span class="star" v-if="item.tags.length">进步之星</span>
        </div>
        <p class="ranking_score">
          <span>{{item.score}}</span>
          分
        </p>
      </div>
      <p class="average_score">- 班级平均分: {{parseInt(ranking_average)}} -</p>
    </div>
    <div class="bottom_box">
      <div v-if="first_visit" class="first">
        <h3>- 您是否希望下次收到这份报告 -</h3>
        <div class="select_box">
          <p v-for="(item, index) in select_list" :class="{'active': index ==selectedIndex}" @click="select(index)">{{item.txt}}</p>
        </div>
        <span v-if="selectedIndex==null">确认</span>
        <span class="active" v-if="selectedIndex!=null" @click="submitOption">确认</span>
      </div>
      <div v-else class="normal">
        <p>如有任何建议，请点击以下链接告知我们</p>
        <p>您的意见对我们很重要</p>
        <span @click="goSuggest">前往填写</span>
      </div>
    </div>
    <loading v-if="loadingLock" :list="list" :loading="loading"></loading>
  </div>
</template>

<style scoped lang="scss">
  @import "@/assets/font/font.scss";

  .entry{
    background-color: #f5f5f5;
    .top-box{
      height: 3.3rem;
      background-color: #f3dec7;
      text-align: center;
      p{
        padding-top: .27rem;
        font-family: PingFangSC-Regular;
        font-size: 0.22rem;
        color: #b37f51;
      }
      h3{
        margin-top: .77rem;
        font-family: PingFangSC-Medium;
        font-size: 0.36rem;
        color: #916e4f;
      }
    }
    .box{
      margin: 0 .3rem .2rem;
      background-color: #ffffff;
      box-shadow: 0rem 0.08rem 0.2rem 0rem rgba(0, 0, 0, 0.08);
      border-radius: 0.16rem;
      .detail_btn{
        position: absolute;
        bottom: .3rem;
        right: .3rem;
        font-family: PingFangSC-Regular;
        font-size: .24rem;
        color: #f5843f;
        i{
          display: inline-block;
          width: .1rem;
          height: .2rem;
          background: url("../../assets/images/arrow_right.png") 0 0/0.1rem 0.2rem no-repeat ;
        }
      }
    }
    .user_box{
      position: relative;
      margin-top: -.76rem;
      height: 5.45rem;
      .userInfo{
        div {
          position: absolute;
          width: 1.15rem;
          height: 1.15rem;
          top: -.5rem;
          left: .32rem;
          img{
            /*position: absolute;*/
            width: 1.15rem;
            height: 1.15rem;
            /*top: -.5rem;*/
            left: .32rem;
            border-radius: 50%;
            border: 2px solid #f3dec8;
            background: url("../../assets/images/user.jpg") 0 0/cover no-repeat;;
          }
        }

        p{
          padding-top: .2rem;
          padding-left: 1.7rem;
          span{
            &:first-child{
              font-family: PingFangSC-Medium;
              font-size: 0.32rem;
              color: #56586a;
              font-weight: bold;
            }
            &:last-child{
              padding-top: .1rem;
              padding-left: .1rem;
              font-family: PingFangSC-Regular;
              font-size: 0.24rem;
              color: #9fa2b8;
            }
          }
        }
      }
      .percent_box{
        margin: .62rem 0 .7rem;
        .itemBox{
          margin: 0 .24rem .2rem;
          position: relative;
          height: 0.28rem;
          .percent_item{
            height: 0.28rem;
            background-color: #fff0c3;
            border-radius: 0.14rem;
            opacity: 0.8;
            overflow: hidden;
            p{
              position: absolute;
              left: 0;
              top: 0;
              width: 68%;
              height: 0.28rem;
              background-color: #f66767;
              border-radius: 0.14rem 0rem 0rem 0.14rem;
              opacity: 0.8;
              border-radius: 0.14rem;
            }
          }
          .img_item{
            position: absolute;
            height: .43rem;
            top: -.1rem;
            width: 100%;
            img{
              position: absolute;
              left: 0;
              width: .43rem;
              height: .43rem;
              z-index: 9;
              border-radius: 50%;
              border: 1px solid #f3dec8;
            }
          }
        }
        .percent_tips{
          position: relative;
          margin: 0 .1rem;
          height: .6rem;
          font-family: PingFangSC-Regular;
          font-size: 0.36rem;
          color: #ffffff;
          .tips_left{
            margin: 0 .1rem;
          }
          .tips_middle{
            margin: 0 auto;
          }
          .tips_right{
            float: right;
          }
          p{
            position: relative;
            height: .16rem;
            margin: 0 .2rem;
            i{
              position: absolute;
              display: inline-block;
              border-left: 7px solid transparent;
              border-right: 7px solid transparent;
              border-bottom: 8px solid #e7be84;
              left: 60%;
              top: 1px;
              content: '';
            }
          }
          .tips_box{
            width: 3.2rem;
            height: .6rem;
            background-color: #e7be84;
            box-shadow: 0rem 0.08rem 0.2rem 0rem rgba(0, 0, 0, 0.08);
            border-radius: 0.3rem;
            position: relative;
            line-height: .6rem;
            text-align: center;
            span{
              font-family: PingFangSC-Regular;
              font-size: .28rem;
              color: #ffffff;
              &:first-child{
                font-family: 'DINCB';
                font-size: 0.36rem;
                color: #ffffff;
              }
              &:last-child{
                font-size: 0.2rem;
                color: #fefefe;
              }
            }
          }
        }
      }
      .user_des{
        position: relative;
        margin-left: .28rem;
        margin-bottom: .2rem;
        padding-left: .36rem;
        i{
          position: absolute;
          width: .2rem;
          height: .25rem;
          top: 3px;
          left: 0;
        }
        i.not::before {
          content: "";
          display: table;
          width: 0.16rem;
          height: 2px;
          background-color: #bdc0d2;
          border-radius: 0.01rem;
          opacity: 0.8;
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -.01rem;;
        }
        .up{
          background: url("../../assets/images/arrow-top-golden.png") 0 0/0.2rem 0.25rem no-repeat ;
        }
        .down{
          background: url("../../assets/images/arrow-bottom-golden.png") 0 0/0.2rem 0.25rem no-repeat ;
        }
        p{
          font-family: PingFangSC-Medium;
          font-size: .26rem;
          color: #56586a;
          font-weight: bold;
          span{
            color: #e7be84;
            padding: 0 .1rem;
          }
        }
      }
    }
    .explain{
      position: relative;
      padding: .4rem 0 0 .48rem;
      height: 3.88rem;
      h3{
        margin-bottom: .5rem;
        font-family: PingFangSC-Medium;
        font-size: .34rem;
        font-weight: bold;
        color: #56586a;
      }
      p{
        margin-bottom: .3rem;
        font-family: PingFangSC-Medium;
        font-size: .3rem;
        line-height: .3rem;
        color: #9fa2b8;
        font-weight: bold;
      }
    }
    .ranking_box{
      padding: .4rem 0 0;
      height: auto;
      background-color: #fff;
      h3{
        margin-bottom: .5rem;
        font-family: PingFangSC-Medium;
        font-size: .34rem;
        color: #56586a;
        font-weight: bold;
        padding: 0 .48rem;
      }
      .ranking_list.active{
        background-color: #fff7e0;
      }
      .ranking_list{
        position: relative;
        height: .96rem;
        line-height: 1.18rem;
        border-bottom: 1px solid #eee;
        padding: 0 .48rem;
        .ranking_num{
          font-family: 'DINCB';
          font-weight: bold;
          font-size: .48rem;
          color: #eec24b;
          line-height: .48rem;
          height: 0.48rem;
        }
        .ranking_num.r1{
          color: #eec24b;
        }
        .ranking_num.r2{
          color: #c6bdce;
        }
        .ranking_num.r3{
          color: #d18126;
        }
        .ranking_num.r4{
        color: #9fa2b8;
        opacity: 0.4;
        }
        .ranking_mark{
          position: absolute;
          top: .26rem;
          left: .9rem;
          width: .2rem;
          height: .5rem;
          i{
            display: block;
            width: .14rem;
            height: .18rem;
          }
          span{
            position: absolute;
            line-height: .24rem;
            bottom: 0;
            font-family: 'DINCB';
            font-weight: bold;
            font-size: .24rem;
            color: #e7be84;
            margin-left: 0.02rem;
          }
          .up{
            background: url("../../assets/images/arrow_up.png") 0 0/0.14rem 0.18rem no-repeat ;
          }
          .down{
            background: url("../../assets/images/arrow_down.png") 0 0/0.14rem 0.18rem no-repeat ;
          }
        }

        .info-wrap{
          display: block;
          height: 0.32rem;
          line-height: 0.32rem;
          position: absolute;
          top: .35rem;
          left: 1.2rem;
          box-sizing: content-box;
          .name{
            font-family: PingFangSC-Medium;
            font-size: .32rem;
            color: #56586a;
            font-weight: bold;
            height: 0.34rem;
            line-height: 0.34rem;
            display: inline-block;
            float: left;
          }
          .me {
            text-align: center;
            color: #fff;
            padding: 0.02rem 0.06rem 0.0rem 0.07rem;
            background-color: #f5833d;
            border-radius: 0.12rem 0px 0.12rem 0px;
            margin-left: 0.1rem;
            font-size: .2rem;
            display: inline-block;
            float: left;
          }
          .star{
            display: inline-block;
            margin-left: .26rem;
            background: #fcd224;
            font-family: PingFangSC-Semibold;
            font-weight: bold;
            font-size: .18rem;
            height: .3rem;
            line-height: .34rem;
            color: #b67725;
            text-align: center;
            padding: 0 0.07rem 0 0.03rem;
            border-radius: 0.02rem;
            float: left;
            position: relative;
            box-sizing: content-box;
          }
          .star::before{
            content: "";
            display: table;
            position: absolute;
            left: -.15rem;
            top: 0;
            height: 0;
            width: 0;
            border-top: 0.15rem solid transparent;
            border-bottom: 0.15rem solid transparent;
            border-right: 0.16rem solid#fcd224;;
          }
        }

        .ranking_score{
          float: right;
          font-family: PingFangSC-Medium;
          font-size: .24rem;
          color: #f5833d;
          height: .96rem;
          line-height: 1.16rem;
          span{
            font-family: 'DINCB';
            font-weight: bold;
            font-size: .46rem;
            display: block;
            float: left;
            height: .96rem;
            line-height: 1.18rem;
            margin-right: .05rem;
          }
        }
      }
      .average_score{
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: .24rem;
        color: #b0b2c0;
        opacity: 0.8;
        height: .6rem;
        line-height: .6rem;
      }
    }
    .bottom_box{
      margin-top: .2rem;
      margin-bottom: .2rem;
      background-color: #fff;
      text-align: center;
      .first{
        padding: 0 .55rem .68rem;
        h3{
          padding: .3rem 0 .18rem;
          font-size: .24rem;
          color: #737373;
          opacity: 0.8;
          font-family: PingFangSC-Semibold;
        }
        .select_box{
          p{
            height: .8rem;
            line-height: .8rem;
            font-family: PingFangSC-Regular;
            font-size: .3rem;
            color: #b0b2c0;
            border-bottom: solid 1px #eeeeee;
            &:last-child{
              border : none;
            }
          }
          p.active {
            background-color: #fff7e0;
          }
        }
        span{
          display: block;
          margin: .28rem auto 0;
          width: 5rem;
          height: .88rem;
          line-height: .88rem;
          background-color: #d0d1d7;
          border-radius: .44rem;
          font-family: PingFangSC-Medium;
          font-size: 0.34rem;
          color: #eaebf0;
        }
        span.active{
          background-color: #e7be84;
        }
      }
      .normal{
        padding: .35rem 0;
        p{
          height: .48rem;
          font-family: PingFangSC-Regular;
          font-size: 0.3rem;
          line-height: .48rem;
          color: #b0b2c0;
        }
        span{
          margin-top: .2rem;
          font-family: PingFangSC-Regular;
          font-size: 0.3rem;
          color: #b37f51;
        }
      }
    }
  }
</style>

<script>
    import ajax from '@/api/ajax'
    import utils from '@/assets/js/utils'
    import loading from '@/components/common/loading.vue'
    import userImg from '@/assets/images/user.jpg'

    export default {
        name: 'entry',
        data() {
            return{
                ranking_list : [],
                ranking_average: 0,
                score_percent : 0,
                positionArr : {
                    arrow_box: "4px",
                    img_box: "0px",
                    percent_box: "11px"
                },
                first_visit : false,
                rankInfo:{},
                loading: true,
                loadingLock: true,
                selectedIndex: null,
                select_list : [],
                submitLock: true,
                time: {},
                token: '',
                date:'',
                isLog: true,
                list: true,
                mode: 1,
                classId: 0
            }
        },
        components:{
            loading
        },
        methods : {
            goToDetail: function () {
                let self = this
                utils.sendLog({
                    token: self.token,
                    version: '3.0.9',
                    source: 'h5'
                }, 'jz0161')
            },
            goToExplain: function () {
                let self = this
                utils.sendLog({
                    token: self.token,
                    version: '3.0.9',
                    source: 'h5'
                }, 'jz0162')
            },
            submitOption: async function () {
                let self = this
                if(!self.submitLock){
                    return
                }
                self.submitLock = false
                const [resp] = await ajax.all([
                    ajax.post('/parent/feed-back/submit', {
                        item: "01",
                        token: self.token,
                        date: self.date
                    }),
                ]).catch((err)=>{
                    console.log(err)
                    self.submitLock = true
                })

                if(resp.data.code == 99999){
                    self.first_visit = false
                }
                self.submitLock = true
            },
            select: function (index) {
                this.selectedIndex = index
            },
            goSuggest : () => {
                window.location.href = 'https://jinshuju.net/f/ffcPjD'
            },
            getRankInfo: async function () {
                let self = this
                const [resp] = await ajax.all([
                    ajax.get('/parent/rank/rank-info', {
                        params: {
                            token: self.token,
                            date: self.date
                        }
                    }),
                ]).catch((err)=>{
                    console.log(err)
                    setTimeout(()=>{
                        self.loading = false
                    }, 100)
                })

                if(resp.data.code == 99999){
                    if(Array.isArray(resp.data.data) && !resp.data.data.length){
                        self.list = false
                        self.loading = false
                        return
                    }

                    self.rankInfo = resp.data.data
                    if(!self.rankInfo.headUrl){
                        self.rankInfo.headUrl = userImg
                    }
                    // console.log('resp.data.data', resp.data.data.rankGrow)
                    if (resp.data.data.rankGrow>0) {
                        self.mode = 1
                    }else if (resp.data.data.rankGrow==0){
                        self.mode = 2
                    }else {
                        self.mode = 3
                        // console.log('0000')
                    }
                    self.time = self.formatDayTime(self.rankInfo.date)
                    self.score_percent = Math.round(resp.data.data.rankScale*100)

                    let percent_box = []
                    let total_width = self.$refs.percent_item.offsetWidth
                    let user_img = self.$refs.user_img.offsetWidth
                    let arrow_box = self.$refs.arrow_box.offsetWidth
                    let img_p = (total_width * self.score_percent/100 + user_img) > total_width ? (total_width * self.score_percent/100 - user_img) : (total_width * self.score_percent/100)
                    let arrow_p = (arrow_box * self.score_percent/100 + 14) > arrow_box ? (arrow_box * self.score_percent/100 - 14) : (arrow_box * self.score_percent/100 + user_img/2 -7)
                    percent_box.img_box = img_p + 'px'
                    percent_box.percent_box = (img_p + user_img/2) + 'px'
                    percent_box.arrow_box = arrow_p + 'px'
                    self.positionArr = percent_box

                    setTimeout(()=>{
                        self.loadingLock = false
                    }, 100)
                }else {
                    setTimeout(()=>{
                        self.loading = false
                    }, 100)
                }
            },
            getRankList: async function () {
                let self = this
                const [resp] = await ajax.all([
                    ajax.get('/parent/rank/rank-list', {
                        params: {
                            token: self.token,
                            date: self.date,
                            classId: self.classId
                        }
                    }),
                ]);
                if(resp.data.code == 99999){
                    // console.log('list', resp.data.data)
                    self.ranking_list = resp.data.data.students
                    self.ranking_average = resp.data.data.average
                }else {

                }
            },
            getOption: async function () {
                let self = this
                const [resp] = await ajax.all([
                    ajax.get('/parent/feed-back/get-feed-back-option', {
                        params: {
                            token: self.token,
                            date: self.date
                        }
                    }),
                ]);
                // console.log('getOption', resp.data.data)
                if(resp.data.code == 99999){
                    self.first_visit = resp.data.data.first
                    const options = resp.data.data.options
                    options && Object.keys(options).forEach((item, index)=>{
                        // console.log('item, index', item, options[item])
                        self.select_list.push({
                            id: item,
                            txt: options[item]
                        })
                    })
                }
            },
            formatDayTime: function (time) {
                // console.log('time', time)
                time = new Date(time.replace(/-/g, '/'))
                let year, month, day, hour, minute, second
                function formate(time) {
                    return time<10? '0'+time : time
                }
                year = formate(time.getFullYear())
                month = formate(time.getMonth()+1)
                day = formate(time.getDate())
                hour = formate(time.getHours())
                minute = formate(time.getMinutes())
                second = formate(time.getSeconds())
                return {
                    year,
                    month,
                    day,
                    hour,
                    minute,
                    second
                }
            },
            sendNodeBotton: function () {
                let self = this, viewHeight = document.documentElement.clientHeight
                if(!self.$refs.rank){
                    return
                }
                let nodeTop = self.$refs.rank.getBoundingClientRect().top
                let nodeHeight = self.$refs.rank.getBoundingClientRect().height
                if(nodeTop +nodeHeight < viewHeight && self.first_visit && self.isLog){
                    self.isLog = false
                    utils.sendLog({
                        token: self.token,
                        version: '3.0.9',
                        source: 'h5'
                    }, 'jz0163')
                }
            },
            handleScroll: function () {
                let self = this
                self.sendNodeBotton()
            },
            setToken: async function() {
                let self = this
                self.token = utils.getQueryString('token')
                self.date = utils.getQueryString('date')
                self.classId = utils.getQueryString('classId')
            }
        },
        destroyed: function () {
            window.removeEventListener('scroll', this.handleScroll)
        },
        created : async function() {
            let self = this
            await self.setToken()
            await self.getRankInfo()
            await self.getRankList()
            await self.getOption()
            utils.sendLog({
                token: self.token,
                version: '3.0.9',
                source: 'h5',
                extensionJson: {
                    mode: self.mode
                }
            }, 'jz0160')
            self.sendNodeBotton()
            window.addEventListener('scroll', self.handleScroll, false)
        },
    }
</script>
